import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CardTwoRow from "../card-two-row/card-two-row";
import { useDispatch, useSelector } from "react-redux";
import { selectOperdons } from "../../redux/operdon/operdon-slice";
import { selectDelSuccessOperdonState, resetDeleteState as resetOperdonDelete} from "../../redux/operdon/operdon-del-slice";
import { toast } from "react-toastify";
import { FaHistory } from "react-icons/fa";
import styles from "./fill-history-services.module.css";


const FillHistoryServices = () => {
  const operDone = useSelector(selectOperdons);
  const dispatch = useDispatch();
  const deleteSuccess = useSelector(selectDelSuccessOperdonState);
    // بعد از حذف موفق، پیام بده و state ریست کن
    useEffect(() => {
      if (deleteSuccess) {
        // نمایش پیام موفقیت
        toast.success("عملیات حذف با موفقیت انجام شد.", {
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
  
        // ریست کردن وضعیت deleteSuccess بعد از مدت زمانی که پیام نشان داده شد
        const timer = setTimeout(() => {
          dispatch(resetOperdonDelete()); // Reset delete state after the toast message disappears
        }, 1000); // This is the same time as the autoClose of the toast message
  
        // پاک کردن تایمر در صورت تغییر وضعیت
        return () => clearTimeout(timer);
      }
    }, [deleteSuccess, dispatch]);


  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  if (!operDone) return <p>در حال بارگذاری...</p>;

  return (
    <div className="slider-container px-2">
      {operDone.length === 0 ? (

            <div className={styles.emptyState}>

                <FaHistory
                    className={styles.emptyIcon}
                />

                <h4>

                    هنوز سابقه‌ای ثبت نشده است

                </h4>

                <p>

                    بعد از ثبت اولین سرویس، سوابق اینجا نمایش داده می‌شوند.

                </p>

            </div>

      ) : (
        <Slider {...settings}>
          {operDone.map((service) => (
            <CardTwoRow
              key={service.id}
              operdon={service}
              car_title={service.car_title}
              serviceTitle={service.opTitle}
              operDate={service.operDonDateP}
              operKM={service.operDonKM}
              cost={service.cost}
            />
          ))}
        </Slider>
      )}
    </div>
  );
};

export default FillHistoryServices;
